<template>
	<div :class="classes">
		<h1 class="label">
			<FontAwesomeIcon
				v-if="recurrenceId"
				class="icon"
				:icon="[ `far`, `calendar-clock`]"
			/>
			{{ label }}
		</h1>
		<h2 class="date">{{ date }}</h2>
	</div>
</template>

<script>
import { TranslateMixin } from "@teaming/common-ui";

export default {
	name: "StreamNavigationCard",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	props: {
		date: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		isActive: {
			type: Boolean,
			required: true,
		},
		recurrenceId: {
			type: String,
			required: false,
		},
	},
	computed: {
		classes() {
			return {
				"stream-navigation-card": true,
				"stream-navigation-card--active": this.isActive,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$labelColor: $color1-700;
$dateColor: $color1-500;
$backgroundColor: $color1-050;

$labelColor--active: $color2-600;
$dateColor--active: $color2-600;
$backgroundColor--active: $color2-100;
$borderColor--active: $color2-600;

.stream-navigation-card {
	padding: 1rem;
	border:0.0625rem solid $borderColor--light;
	background-color: $backgroundColor;
	border-radius: 0.5rem;

	text-align: left;
	cursor: pointer;

	&:hover {
		border-color: $borderColor--dark;
	}
}

.stream-navigation-card > .label {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $labelColor;

	.icon {
		color: $dateColor;
	}
}

.stream-navigation-card > .date {
	@include font-and-line-for(-1);
	font-weight: 450;
	color: $dateColor;
}

.stream-navigation-card--active {
	background-color: $backgroundColor--active;
	border-color: $borderColor--active;

	> .label {
		color: $labelColor--active;
	}

	> .date {
		color: $dateColor--active;
	}

	&:hover {
		border-color: $borderColor--active;
	}
}
</style>
